import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Calculator, DollarSign, MapPin, ArrowRight, CheckCircle2, Package } from 'lucide-react';
import { Button } from '../components/ui/button';
import { motion } from 'framer-motion';

const STATE_TAX_DATA = [
  { code: 'AL', name: 'Alabama', perPack: 0.675, perCarton: 6.75 },
  { code: 'AK', name: 'Alaska', perPack: 2.00, perCarton: 20.00 },
  { code: 'AZ', name: 'Arizona', perPack: 2.00, perCarton: 20.00 },
  { code: 'AR', name: 'Arkansas', perPack: 1.15, perCarton: 11.50 },
  { code: 'CA', name: 'California', perPack: 2.87, perCarton: 28.70 },
  { code: 'CO', name: 'Colorado', perPack: 1.94, perCarton: 19.40 },
  { code: 'CT', name: 'Connecticut', perPack: 4.35, perCarton: 43.50 },
  { code: 'DE', name: 'Delaware', perPack: 2.10, perCarton: 21.00 },
  { code: 'FL', name: 'Florida', perPack: 1.339, perCarton: 13.39 },
  { code: 'GA', name: 'Georgia', perPack: 0.37, perCarton: 3.70 },
  { code: 'HI', name: 'Hawaii', perPack: 3.20, perCarton: 32.00 },
  { code: 'ID', name: 'Idaho', perPack: 0.57, perCarton: 5.70 },
  { code: 'IL', name: 'Illinois', perPack: 2.98, perCarton: 29.80 },
  { code: 'IN', name: 'Indiana', perPack: 0.995, perCarton: 9.95 },
  { code: 'IA', name: 'Iowa', perPack: 1.36, perCarton: 13.60 },
  { code: 'KS', name: 'Kansas', perPack: 1.29, perCarton: 12.90 },
  { code: 'KY', name: 'Kentucky', perPack: 1.10, perCarton: 11.00 },
  { code: 'LA', name: 'Louisiana', perPack: 1.08, perCarton: 10.80 },
  { code: 'ME', name: 'Maine', perPack: 2.00, perCarton: 20.00 },
  { code: 'MD', name: 'Maryland', perPack: 3.75, perCarton: 37.50 },
  { code: 'MA', name: 'Massachusetts', perPack: 3.51, perCarton: 35.10 },
  { code: 'MI', name: 'Michigan', perPack: 2.00, perCarton: 20.00 },
  { code: 'MN', name: 'Minnesota', perPack: 3.04, perCarton: 30.40 },
  { code: 'MS', name: 'Mississippi', perPack: 0.68, perCarton: 6.80 },
  { code: 'MO', name: 'Missouri', perPack: 0.17, perCarton: 1.70 },
  { code: 'MT', name: 'Montana', perPack: 1.70, perCarton: 17.00 },
  { code: 'NE', name: 'Nebraska', perPack: 0.64, perCarton: 6.40 },
  { code: 'NV', name: 'Nevada', perPack: 1.80, perCarton: 18.00 },
  { code: 'NH', name: 'New Hampshire', perPack: 1.78, perCarton: 17.80 },
  { code: 'NJ', name: 'New Jersey', perPack: 2.70, perCarton: 27.00 },
  { code: 'NM', name: 'New Mexico', perPack: 2.00, perCarton: 20.00 },
  { code: 'NY', name: 'New York', perPack: 4.35, perCarton: 43.50 },
  { code: 'NC', name: 'North Carolina', perPack: 0.45, perCarton: 4.50 },
  { code: 'ND', name: 'North Dakota', perPack: 0.44, perCarton: 4.40 },
  { code: 'OH', name: 'Ohio', perPack: 1.60, perCarton: 16.00 },
  { code: 'OK', name: 'Oklahoma', perPack: 2.03, perCarton: 20.30 },
  { code: 'OR', name: 'Oregon', perPack: 3.33, perCarton: 33.30 },
  { code: 'PA', name: 'Pennsylvania', perPack: 2.60, perCarton: 26.00 },
  { code: 'RI', name: 'Rhode Island', perPack: 4.25, perCarton: 42.50 },
  { code: 'SC', name: 'South Carolina', perPack: 0.57, perCarton: 5.70 },
  { code: 'SD', name: 'South Dakota', perPack: 1.53, perCarton: 15.30 },
  { code: 'TN', name: 'Tennessee', perPack: 0.62, perCarton: 6.20 },
  { code: 'TX', name: 'Texas', perPack: 1.41, perCarton: 14.10 },
  { code: 'UT', name: 'Utah', perPack: 1.70, perCarton: 17.00 },
  { code: 'VT', name: 'Vermont', perPack: 3.08, perCarton: 30.80 },
  { code: 'VA', name: 'Virginia', perPack: 0.60, perCarton: 6.00 },
  { code: 'WA', name: 'Washington', perPack: 3.025, perCarton: 30.25 },
  { code: 'WV', name: 'West Virginia', perPack: 1.20, perCarton: 12.00 },
  { code: 'WI', name: 'Wisconsin', perPack: 2.52, perCarton: 25.20 },
  { code: 'WY', name: 'Wyoming', perPack: 0.60, perCarton: 6.00 },
  { code: 'DC', name: 'Washington D.C.', perPack: 4.98, perCarton: 49.80 },
];

export default function TobaccoTaxCalculator() {
  const [state, setState] = useState('');
  const [cartons, setCartons] = useState('');
  const [packs, setPacks] = useState('');
  const [period, setPeriod] = useState('month');

  // SEO: Set page title
  React.useEffect(() => {
    document.title = 'Tobacco Excise Tax Calculator by State (2025) | FlowFeed POS';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Free tobacco excise tax calculator for all 50 US states. Calculate cigarette tax per pack and carton with 2025 rates. No signup required.');
    return () => { document.title = 'FlowFeed POS | #1 Point of Sale for Smoke Shops, C-Stores & Gas Stations'; };
  }, []);

  const selectedState = STATE_TAX_DATA.find(s => s.code === state);
  
  const totalPacks = (parseInt(cartons) || 0) * 10 + (parseInt(packs) || 0);
  const taxPerPeriod = selectedState ? totalPacks * selectedState.perPack : 0;
  const annualTax = period === 'month' ? taxPerPeriod * 12 : period === 'week' ? taxPerPeriod * 52 : taxPerPeriod;

  return (
    <div className="min-h-screen bg-white dark:bg-slate-950">
      {/* Nav */}
      <nav className="border-b border-slate-200 dark:border-slate-800 bg-white/80 dark:bg-slate-950/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-lg bg-emerald-600 flex items-center justify-center">
              <Package className="h-5 w-5 text-white" />
            </div>
            <span className="font-bold text-lg text-slate-900 dark:text-white">FlowFeed</span>
          </Link>
          <div className="flex items-center gap-3">
            <Link to="/signup">
              <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700 text-white">
                Start Free Trial
              </Button>
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="py-12 md:py-20">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
              className="inline-flex items-center gap-2 rounded-full border border-emerald-500/30 bg-emerald-50 dark:bg-emerald-950 px-4 py-1.5 text-sm font-medium text-emerald-700 dark:text-emerald-400 mb-4">
              <Calculator className="h-4 w-4" /> Free Tool
            </motion.div>
            <h1 className="text-3xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
              Tobacco Excise Tax Calculator
            </h1>
            <p className="text-lg text-slate-600 dark:text-slate-400">
              Calculate your state tobacco excise tax liability instantly. All 50 states + D.C. with 2025 rates.
            </p>
          </div>

          {/* Calculator */}
          <div className="max-w-2xl mx-auto">
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}
              className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-2xl p-6 md:p-8 shadow-xl"
              data-testid="tax-calculator">
              
              {/* State Selector */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                  <MapPin className="h-4 w-4 inline mr-1" /> Select Your State
                </label>
                <select value={state} onChange={(e) => setState(e.target.value)}
                  className="w-full h-12 px-4 rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-white text-lg"
                  data-testid="state-selector">
                  <option value="">-- Choose State --</option>
                  {STATE_TAX_DATA.map(s => (
                    <option key={s.code} value={s.code}>{s.name} (${s.perPack}/pack)</option>
                  ))}
                </select>
              </div>

              {/* Quantity Inputs */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div>
                  <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                    Cartons Sold
                  </label>
                  <input type="number" value={cartons} onChange={(e) => setCartons(e.target.value)}
                    placeholder="0" min="0"
                    className="w-full h-12 px-4 rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-white text-lg"
                    data-testid="cartons-input" />
                  <p className="text-xs text-slate-500 mt-1">10 packs per carton</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                    Individual Packs
                  </label>
                  <input type="number" value={packs} onChange={(e) => setPacks(e.target.value)}
                    placeholder="0" min="0"
                    className="w-full h-12 px-4 rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-white text-lg"
                    data-testid="packs-input" />
                  <p className="text-xs text-slate-500 mt-1">Loose packs sold</p>
                </div>
              </div>

              {/* Period */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                  Sales Period
                </label>
                <div className="flex gap-2">
                  {[{v: 'week', l: 'Per Week'}, {v: 'month', l: 'Per Month'}, {v: 'year', l: 'Per Year'}].map(p => (
                    <button key={p.v} onClick={() => setPeriod(p.v)}
                      className={`flex-1 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                        period === p.v
                          ? 'bg-emerald-600 text-white'
                          : 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 hover:bg-slate-200'
                      }`} data-testid={`period-${p.v}`}>
                      {p.l}
                    </button>
                  ))}
                </div>
              </div>

              {/* Results */}
              {selectedState && totalPacks > 0 && (
                <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }}
                  className="border-t border-slate-200 dark:border-slate-700 pt-6 space-y-4"
                  data-testid="tax-results">
                  <div className="bg-emerald-50 dark:bg-emerald-950/30 rounded-xl p-5 border border-emerald-200 dark:border-emerald-800">
                    <p className="text-sm text-emerald-700 dark:text-emerald-400 mb-1">
                      Estimated Excise Tax — {selectedState.name} ({period === 'week' ? 'Weekly' : period === 'month' ? 'Monthly' : 'Annually'})
                    </p>
                    <p className="text-4xl font-bold text-emerald-700 dark:text-emerald-400" data-testid="tax-amount">
                      ${taxPerPeriod.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </p>
                  </div>
                  
                  <div className="grid grid-cols-3 gap-3 text-center">
                    <div className="bg-slate-50 dark:bg-slate-800 rounded-lg p-3">
                      <p className="text-xs text-slate-500 mb-1">Total Packs</p>
                      <p className="text-lg font-bold text-slate-900 dark:text-white">{totalPacks}</p>
                    </div>
                    <div className="bg-slate-50 dark:bg-slate-800 rounded-lg p-3">
                      <p className="text-xs text-slate-500 mb-1">Tax/Pack</p>
                      <p className="text-lg font-bold text-slate-900 dark:text-white">${selectedState.perPack}</p>
                    </div>
                    <div className="bg-slate-50 dark:bg-slate-800 rounded-lg p-3">
                      <p className="text-xs text-slate-500 mb-1">Annual Est.</p>
                      <p className="text-lg font-bold text-slate-900 dark:text-white">${annualTax.toLocaleString(undefined, { maximumFractionDigits: 0 })}</p>
                    </div>
                  </div>

                  <p className="text-xs text-slate-500 text-center">
                    Based on {selectedState.name} state excise tax rate of ${selectedState.perPack}/pack. 
                    Does not include local/city taxes or federal taxes. Rates effective 2025.
                  </p>
                </motion.div>
              )}
            </motion.div>

            {/* CTA */}
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}
              className="mt-8 text-center bg-gradient-to-r from-emerald-600 to-blue-600 rounded-2xl p-6 md:p-8 text-white"
              data-testid="calculator-cta">
              <h2 className="text-xl md:text-2xl font-bold mb-2">
                Automate Your Tobacco Tax Reports
              </h2>
              <p className="text-emerald-100 mb-4 text-sm md:text-base">
                FlowFeed POS automatically tracks tobacco sales, calculates excise tax, and generates 
                state-compliant reports — no manual counting needed.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link to="/signup">
                  <Button size="lg" className="bg-white text-emerald-700 hover:bg-emerald-50 font-semibold px-6">
                    Start Free 14-Day Trial <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
              </div>
              <div className="flex items-center justify-center gap-4 mt-4 text-xs text-emerald-200">
                <span className="flex items-center gap-1"><CheckCircle2 className="h-3 w-3" /> No credit card</span>
                <span className="flex items-center gap-1"><CheckCircle2 className="h-3 w-3" /> Auto tax reports</span>
                <span className="flex items-center gap-1"><CheckCircle2 className="h-3 w-3" /> All 50 states</span>
              </div>
            </motion.div>
          </div>

          {/* SEO Content — State Tax Table */}
          <div className="max-w-4xl mx-auto mt-16">
            <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-6 text-center">
              Cigarette Excise Tax Rates by State (2025)
            </h2>
            <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="bg-slate-50 dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700">
                      <th className="px-4 py-3 text-left font-medium text-slate-600 dark:text-slate-400">State</th>
                      <th className="px-4 py-3 text-right font-medium text-slate-600 dark:text-slate-400">Tax Per Pack</th>
                      <th className="px-4 py-3 text-right font-medium text-slate-600 dark:text-slate-400">Tax Per Carton</th>
                      <th className="px-4 py-3 text-right font-medium text-slate-600 dark:text-slate-400">100 Cartons/mo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {STATE_TAX_DATA.sort((a, b) => b.perPack - a.perPack).map((s, idx) => (
                      <tr key={s.code} className={`border-b border-slate-100 dark:border-slate-800 ${idx % 2 === 0 ? '' : 'bg-slate-50/50 dark:bg-slate-800/30'}`}>
                        <td className="px-4 py-2.5 font-medium text-slate-900 dark:text-white">{s.name}</td>
                        <td className="px-4 py-2.5 text-right text-slate-700 dark:text-slate-300">${s.perPack.toFixed(3)}</td>
                        <td className="px-4 py-2.5 text-right text-slate-700 dark:text-slate-300">${s.perCarton.toFixed(2)}</td>
                        <td className="px-4 py-2.5 text-right font-semibold text-red-600">${(s.perCarton * 100).toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <p className="text-xs text-slate-500 text-center mt-3">
              Source: Tax Foundation, state revenue departments. Rates as of January 2025. 
              Local/city taxes not included. Always verify with your state tax authority.
            </p>
          </div>

          {/* FAQ Section for SEO */}
          <div className="max-w-3xl mx-auto mt-16 mb-12">
            <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-6 text-center">
              Frequently Asked Questions
            </h2>
            <div className="space-y-4">
              {[
                { q: "How is tobacco excise tax calculated?", a: "Tobacco excise tax is a per-unit tax levied by each state on the sale of tobacco products. For cigarettes, it's typically charged per pack (20 cigarettes). The rate varies dramatically by state — from $0.17/pack in Missouri to $4.98/pack in Washington D.C." },
                { q: "Who pays the tobacco excise tax?", a: "The excise tax is typically paid by the wholesaler or distributor and passed on to retailers in the product cost. However, retailers are responsible for collecting and remitting any additional state/local sales tax on the final sale price." },
                { q: "How often do I need to file tobacco tax reports?", a: "Filing frequency varies by state. Most states require monthly reporting, but some allow quarterly filing for smaller retailers. Late filings can result in penalties of 5-25% of tax owed plus interest." },
                { q: "Does this calculator include local city taxes?", a: "No, this calculator shows state-level excise tax only. Some cities (like Chicago, New York City, Philadelphia) levy additional local tobacco taxes. Check with your local tax authority for combined rates." },
                { q: "How can I automate tobacco tax reporting?", a: "POS systems like FlowFeed automatically track every tobacco sale, categorize by product type, and generate state-compliant tax reports. This eliminates manual counting and reduces filing errors that can trigger audits." },
              ].map((faq, idx) => (
                <details key={idx} className="bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-200 dark:border-slate-700 group">
                  <summary className="px-5 py-4 cursor-pointer font-medium text-slate-900 dark:text-white list-none flex items-center justify-between">
                    {faq.q}
                    <span className="text-slate-400 group-open:rotate-45 transition-transform text-xl">+</span>
                  </summary>
                  <p className="px-5 pb-4 text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                    {faq.a}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-slate-200 dark:border-slate-800 py-6">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">&copy; 2025 FlowFeed. Free tobacco tax calculator for US retailers.</p>
          <div className="flex items-center gap-4 text-sm text-slate-500">
            <Link to="/" className="hover:text-emerald-600 transition-colors">Home</Link>
            <Link to="/signup" className="hover:text-emerald-600 transition-colors">Sign Up</Link>
            <Link to="/login" className="hover:text-emerald-600 transition-colors">Login</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
